module.exports = {
  common: {
    welcome: 'Bienvenido',
    lang: 'Idiomas',
    currentLang: 'Español',
    clear: 'Vacio',
    noMore: 'No hay más',
    seeAll: 'Ver todo',
    see: 'Ver',
    add: 'Añadir',
    select: 'Seleccionar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    password: 'Contraseña',
    needPasswordTip: 'Por favor, rellene la contraseña',
    selectTip: 'Por favor, elija',
    fillTip: 'Por favor, rellene',
    submit: 'Presentación',
    default: 'Predeterminado',
    deleteSuccess: 'Eliminación exitosa',
    addSuccess: 'Se agregó con éxito',
    editSuccess: 'Modificación exitosa',
    welcome: 'Bienvenido',
    startUpload: 'Comienza a cargar',
    uploadSuccess: 'Carga exitosa',
    remark: 'Observaciones',
    agree: 'Acordar los',
  },
  login: {
    registTip: '¿quieres ser miembro y disfrutar de productos con descuento?',
    contactUs: 'Contáctanos',
    tip4supplier: 'Soporte técnico StarPay',
  },
  product: {
    title: 'Producto',
    all: 'Todos los clasificación',
    name: 'Nombre de la mercancía',
    spec: 'Especificación',
    unit: 'Unidad',
    price: 'Precio',
    addToCart: 'Agregar a coche',
    buyCount: 'Cantidad comprada',
    selectSpecTip: 'Por favor, elija las especificaciones',
    addedToCartTip: 'Se ha añadido al carrito de la compra',
    category: 'Clasificación',
  },
  shoppingcart: {
    title: 'Carrito',
    noAddressTip: 'Seleccione la dirección de envío',
    productOriginalPrice: 'Precio original',
    deposit: 'Adelanto',
    agentFreight: 'Flete de agencia',
    payPrice: 'Importe',
    accountBalance: 'Saldo',
    payAndOrderButton: 'Pago y genera pedido',
    ordering: 'Generación de pedidos...',
    noProduct2Buy: 'No hay bienes para comprar',
    selectAddressTip: 'Por favor, seleccione la dirección de envío',
    notEnoughMoney: 'Saldo insuficiente de la cuenta',
    buyedTip: 'Compra exitosa, Se puede ingresar a la columna de pedidos para ver',
    needTransport: 'Necesidad de transporte',
    orderPrice4transportFree: 'Pedido completo {0}SOL, gratuito',
    termsOfPurchase: 'cláusula de compra',
    termsTip: 'Es necesario acordar los términos de compra',
  },
  address: {
    add: 'Agregar Nueva dirección',
    idNumber: 'RUC/DNI',
  },
  order: {
    title: 'Pedidos',
    needDeposit: 'Depósito a pagar',
    unDeliver: 'Por despacho',
    delivering: 'En envio',
    received: 'Entregado',
    needBalance: 'Saldo pendiente',
    all: 'Todos los pedidos',
    number: 'Número de pedidos',
    priceDetail: 'Detalle de precios',
    originalPrice: 'Precio original',
    deposit: 'Adelanto',
    agentFreight: 'Flete de agencia',
    seeProducts: 'Vista del producto',
    payOrder: 'Orden de Pago',
    confirmPayBalance: 'Confirmación del pago final?',
    paySuccess: 'Pago exitoso',
    needPay: 'Cuentas por pagar actuales',
    serviceFee: 'Cargo por servicios',
    otherPayMethod: 'Otros métodos de pago',
    creditCard: 'Tarjeta de crédito',
  },
  user: {
    title: 'Usuarios',
    capitalFlow: 'Flujo de fondos',
    rechargeApply: 'Solicitud de recarga',
    ourContactInfo: 'Nuestros datos de contacto',
    phone: 'Teléfono',
    call: 'Llamada',
    contact: 'Contacto',
    processing: 'En proceso...',
    rechargeTip: 'La recarga de las transferencias en',
    rechargeBank: 'Banco: BBVA Continental',
    rechargeBankAccount: 'Número Cuenta: 0011 0370 0200471779',
    rechargeCCI: 'CCI: 011 370 000200471779 45',
    rechargeCompanyName: 'Nombre de la empresa: STARPAY DIGITAL S.A.C.',
    rechargeUploadDes: 'Si la remesa es exitosa, suba la imagen del comprobante, y completaremos el procesamiento de recarga en 24 horas.',
    rechargeAmount: 'Cantidad recargada',
    rechargeAmountTip: 'Por favor, rellene el monto de recarga.',
    rechargeUploadTip: 'Por favor, suba la imagen del comprobante',
    rechargeSubmitedTip: 'La solicitud de recarga se presentó con éxito, y completaremos el procesamiento de recarga en 24 horas. ¡¡ gracias por su apoyo!',
  },
  account: {
    login: 'Iniciar sesión',
    loginTip: 'Por favor, inicie sesión primero',
    loginSuccess: 'Inicio de sesión exitoso',
    userName: 'Nombre de usuario',
    needUserNameTip: 'Por favor, rellene el nombre de usuario',
    changePassword: 'Modificar la contraseña',
    oldPassword: 'Actual contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    confirmPasswordWrong: 'Actual contraseña incorrecta',
    fillPasswordTip: 'Por favor, rellene el contraseña',
    reLoginTip: 'Por favor, vuelva a iniciar sesión',
    logout: 'Cancelación',
  },
}
